import React from "react";
import { NavLink } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/patients", label: "Patients" },
  { to: "/sessions", label: "Sessions" },
  { to: "/relation-graph", label: "Clinical Graph" },
  { to: "/brain-map", label: "Brain Map" },
  { to: "/reviews", label: "Reviews" },
  { to: "/settings", label: "Settings" },
];

export default function AppSidebar({ user, onNavigate }) {
  const isAdmin = user?.role === "admin";
  const isResearcher = user?.role === "researcher";
  const canAccessResearch = isAdmin || isResearcher;

  return (
    <aside className="app-sidebar">
      <div className="app-sidebar-inner">
        <div className="app-sidebar-title">Workspace</div>

        <nav className="app-sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) =>
                `app-nav-link ${isActive ? "active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}

          {canAccessResearch && (
            <NavLink
              to="/research"
              onClick={onNavigate}
              className={({ isActive }) =>
                `app-nav-link ${isActive ? "active" : ""}`
              }
            >
              Research Lab
            </NavLink>
          )}

          {isAdmin && (
            <>
              <div className="app-sidebar-title app-sidebar-title-small">
                Admin
              </div>

              <NavLink
                to="/admin/approvals"
                onClick={onNavigate}
                className={({ isActive }) =>
                  `app-nav-link ${isActive ? "active" : ""}`
                }
              >
                Admin Approvals
              </NavLink>

              <NavLink
                to="/admin/system"
                onClick={onNavigate}
                className={({ isActive }) =>
                  `app-nav-link ${isActive ? "active" : ""}`
                }
              >
                Admin System
              </NavLink>
            </>
          )}
        </nav>
      </div>
    </aside>
  );
}